import type { Product } from "@/models/product";
import type { WindowFabricColor } from "@/store/selection";

export type ResolvedSelectionColors = {
    productName: string;
    fabricColorHex: string | null;
    fabricColorName: string | null;
    frameColorHex: string | null;
    frameColorName: string | null;
};

export function resolveSelectionColors(
    cmsProduct: Product | null | undefined,
    selection: WindowFabricColor,
    fallbackProductName: string,
): ResolvedSelectionColors {
    const fabricColor = cmsProduct?.fabricColors.find(
        (c) => c.id === selection.colorId,
    );
    const frameColor = cmsProduct?.frameColors.find(
        (c) => c.id === selection.frameColorId,
    );

    return {
        productName: cmsProduct?.name ?? fallbackProductName,
        fabricColorHex: fabricColor?.hexColor ?? selection.colorHex,
        fabricColorName: fabricColor?.name ?? selection.colorName,
        frameColorHex: frameColor?.hexColor ?? selection.frameColorHex,
        frameColorName: frameColor?.name ?? selection.frameColorName,
    };
}
